import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';

const AutosaveIndicator = ({ isSaving, lastSaved }) => {
  const [showSaved, setShowSaved] = useState(false);

  useEffect(() => {
    if (!isSaving && lastSaved) {
      setShowSaved(true);
      const timer = setTimeout(() => setShowSaved(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isSaving, lastSaved]);

  if (isSaving) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 bg-muted rounded-lg">
        <div className="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin" />
        <span className="text-sm text-muted-foreground">Saving...</span>
      </div>
    );
  }

  if (showSaved) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 bg-success/10 text-success rounded-lg animate-fade-in">
        <Icon name="Check" size={16} color="currentColor" />
        <span className="text-sm">Saved</span>
      </div>
    );
  }

  return null;
};

export default AutosaveIndicator;